import { type FC } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import communityData from '../../data/awmCommunityInfoData.json';

import './HomeDescription.css';

const HomeDescription: FC = () => {
  const { TOTAL_ACRES, TOTAL_PLOTS, TOTAL_PHASES } =
    communityData.communityStats;

  return (
    <section className="home-description-section">
      <Container>
        <Row>
          <Col md={12}>
            <div className="home-description-text">
              <p>
                <strong>Aparna Western Meadows</strong>, a vibrant and secure
                community spanning {TOTAL_ACRES} acres and offering{' '}
                {TOTAL_PLOTS} residential plots across {TOTAL_PHASES}{' '}
                beautifully developed phases. Our community is built with a
                strong emphasis on ensuring the safety, dignity, and well-being
                of all residents.
              </p>
              <p>
                Aparna Western Meadows offers a host of amenities designed to
                provide peace of mind and convenience. With 24/7 security in
                place, residents can feel secure knowing their safety is a top
                priority. The entire community is also equipped with CCTV
                surveillance, ensuring constant monitoring for added protection.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HomeDescription;
